import { render, staticRenderFns } from "./SimpleSearch.vue?vue&type=template&id=13558c39&lang=pug&"
import script from "./SimpleSearch.vue?vue&type=script&lang=js&"
export * from "./SimpleSearch.vue?vue&type=script&lang=js&"
import style0 from "./SimpleSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports